// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 762) return "static/chunks/762-d7009ba8a7cfedce.js";
	if (chunkId === 9043) return "static/chunks/9043-f937ff42192fc078.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1393":"5239054200c1ff1f","8804":"e4be2aa3a4d4d75d"}[chunkId] + ".js";
};